import React, {PropsWithChildren, useEffect, useState} from 'react';
import { PostalCodeLocation } from '../types/location';
export type LocationContextType = {
  value: string | null;
  set: (value: string) => void;
};

export const LocationContext = React.createContext<LocationContextType | null>(
  null,
);

const USER_LOCATION_LOCAL_STORAGE = 'vwca-user-location';

export const LocationContextProvider = (props : PropsWithChildren) => {
  const [postalCode, setPostalCode] = useState<string | null>(null);

  const setLocalPostalCode = async (postalCodeValue: string) => {
    const localPostalCodeData: PostalCodeLocation = {
      type: 'postalCode',
      postalCode: postalCodeValue.toUpperCase(),
    };

    window.localStorage.setItem(
      USER_LOCATION_LOCAL_STORAGE,
      JSON.stringify(localPostalCodeData),
    );
  };

  const onSetPostalCode = (postalCodeValue: string) => {
    setPostalCode(postalCodeValue);
    setLocalPostalCode(postalCodeValue);
  };

  const setParsedPostalCode = () => {
    const localPostalCodeLocation = localStorage.getItem(
      USER_LOCATION_LOCAL_STORAGE,
    );
    const localPostalCodeLocationParsed = JSON.parse(
      localPostalCodeLocation as string,
    );

    setPostalCode(localPostalCodeLocationParsed.postalCode);
  };

  useEffect(() => {
    if (localStorage.getItem(USER_LOCATION_LOCAL_STORAGE))
      setParsedPostalCode();

    window.onstorage = () => {
      if (localStorage.getItem(USER_LOCATION_LOCAL_STORAGE))
        setTimeout(() => setParsedPostalCode(), 500);
    };
  }, []);

  const LocationContextValue: LocationContextType = {
    value: postalCode,
    set: onSetPostalCode,
  };

  return (
    <LocationContext.Provider value={LocationContextValue}>
      {props.children}
    </LocationContext.Provider>
  );
};
